function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Controls } from 'shared/helper/form';
import { T, useTranslate } from 'shared/helper/translate';
var Text = Controls.Text;
var journalUrlValid = function journalUrlValid(val) {
  return val && val.length > 0 ? val.match(/^https?:\/\//) : true;
};
var JournalPreview = function JournalPreview(_ref) {
  var fetchJournalDetails = _ref.fetchJournalDetails,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    journal = _ref.journal,
    journalUrl = _ref.journalUrl,
    clearJournal = _ref.clearJournal,
    methods = _ref.methods,
    styles = _ref.styles;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    fetchingDetails = _useState2[0],
    setFetchingDetails = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    suggestedUrl = _useState4[0],
    setSuggestedUrl = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    urlMismatch = _useState6[0],
    setUrlMismatch = _useState6[1];
  var setJournalUrl = function setJournalUrl(url) {
    return methods.setValue('journal.url', url);
  };
  var checkUrlMatches = function checkUrlMatches(url) {
    return setUrlMismatch(suggestedUrl && suggestedUrl !== url);
  };
  var handleUseSuggestedUrl = function handleUseSuggestedUrl() {
    setJournalUrl(suggestedUrl);
    checkUrlMatches(suggestedUrl);
  };
  useEffect(function () {
    if (journalUrl) {
      setSuggestedUrl(journalUrl);
      setUrlMismatch(false);
    }
  }, [journalUrl]);
  useEffect(function () {
    // If we already have a journalUrl, there's no need go grab a new one
    if (journalUrl || !journal || !journal.ISSN) {
      return;
    }
    setFetchingDetails(true);
    fetchJournalDetails(journal).then(function (_ref2) {
      var url = _ref2.url;
      setJournalUrl(url);
      setSuggestedUrl(url);
      setFetchingDetails(false);
    });
  }, [journal && journal.title]);
  var journalTitle = journal.name && journal.name.label ? journal.name.label : journal.title || journal.label;
  return /*#__PURE__*/React.createElement("div", {
    className: "journal-preview ".concat(styles.journalPreview || '')
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Remove'),
    type: "button",
    disabled: disabled,
    onClick: clearJournal,
    className: "float-end btn-link"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Remove"
  })), /*#__PURE__*/React.createElement("b", null, journalTitle), journal.publisher ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(T, {
    source: "Publisher"
  }), ":"), ' ', journal.publisher) : null, /*#__PURE__*/React.createElement("div", {
    className: "journal-preview-website"
  }, fetchingDetails ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "float-end",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(T, {
    source: "Website"
  }), ":"), /*#__PURE__*/React.createElement("div", {
    className: "w-100"
  }, /*#__PURE__*/React.createElement(Text, {
    className: "form-control",
    readOnly: disabled,
    maxLength: "255",
    name: "journal.url",
    validators: {
      journalUrlValid: journalUrlValid
    },
    placeholder: t('-- Paste in web address here --'),
    onBlur: function onBlur(_ref3) {
      var value = _ref3.target.value;
      return checkUrlMatches(value);
    }
  }), urlMismatch ? /*#__PURE__*/React.createElement("div", {
    className: "suggested-url text-truncate"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Use'),
    type: "button",
    className: "label label-primary bg-primary p-1",
    onClick: handleUseSuggestedUrl
  }, /*#__PURE__*/React.createElement(T, {
    source: "use"
  })), /*#__PURE__*/React.createElement("span", null, suggestedUrl)) : null)));
};
export default JournalPreview;